import { useRef } from 'react';
import PeriodComparison from '@/components/PeriodComparison';
import { PeriodComparison as PeriodComparisonType } from '@/types/AnalysisResultType';
import { useResponsiveFontSize } from '@/hooks/useResponsiveFontSize';

interface ScoreItem {
    type: string;
    value: string;
}

interface ScoreCardProps {
    title: string;
    score: ScoreItem[];
    comparison?: PeriodComparisonType;
    comparisonValueType?: 'time' | 'number' | 'percentage';
    emptyLabel?: string;
}

const ScoreCard: React.FC<ScoreCardProps> = ({
    title,
    score,
    comparison,
    comparisonValueType = 'number',
    emptyLabel = 'No data',
}) => {
    // レスポンシブ対応
    const containerRef = useRef<HTMLDivElement>(null);
    // 動的なフォントサイズを取得
    const fontSize = useResponsiveFontSize(containerRef);

    // データが存在しない場合
    if (score.length === 0 || score[0]?.value?.length === 0) {
        return (
            <div className="items-center justify-center text-center">
                <p className="text-xl">{title}</p>
                <br />
                <p className="">{emptyLabel}</p>
            </div>
        );
    }

    /**
     * レンダリング
     */
    return (
        <div
            ref={containerRef}
            style={{ fontSize: `${fontSize}px` }}
            className="w-full h-full flex flex-col justify-center items-center text-center"
        >
            {/* タイトル */}
            <p className="justify-center" style={{ fontSize: '1.6em' }}>
                {title}
            </p>
            {/* スコア */}
            <div className="flex items-baseline justify-center">
                {/* 値と単位で分けて表示 */}
                {score.map((item, index) => (
                    <span
                        key={index}
                        className={item.type !== 'number' ? 'text-gray-500 mx-1' : ''}
                        style={{
                            fontSize: item.type !== 'number' ? '2.4em' : '4em',
                        }}
                    >
                        {item.value}
                    </span>
                ))}
            </div>
            {/* 前期比表示 */}
            {comparison &&
                comparison.previousValue !== undefined &&
                comparison.previousValue !== null && (
                    <PeriodComparison
                        comparison={comparison}
                        valueType={comparisonValueType}
                        className={`justify-center text-sm`}
                    />
                )}
        </div>
    );
};

export default ScoreCard;
